import { Stack } from '@mui/material'
import React from 'react'
import { CustomButton } from '../../../../../components/Button/Button'

const CardNotFound = ({handleReload, title, btnTitle,icon}) => {
  return (
    <Stack height={"80vh"} justifyContent={"center"} alignItems={"center"}>
    <div className='cardNotFound'>
      <img src={icon} alt="error" style={{ height: "140px" }} />
      <h2>{title}</h2>
      <CustomButton
        variant="outlined"
        color="error"
        sx={{ marginTop: "16px" }}
        onClick={handleReload}
      >
       {btnTitle}
      </CustomButton>
    </div>
  </Stack>
  )
}

export default CardNotFound